export default __webpack_public_path__ + "static/media/booking.ae708316.png";